import React from 'react';
import { connect } from 'react-redux';
import { ValidMe } from '../../../../businessLogic/validation.js';
import Txt from '../../../inputs/textInput.js';
import {
  updateCurrentCreateWaitingAreaStep,
  updateCurrentFilledWaitingAreaStep,
  updateWaitingAreaForm,
} from '../../../../actions/waitingArea.js';
import { clone } from '../../../../reducers/helper.js';

const SECTIONS_NUMBER = 4;

@connect(mapStateToProps)
export default class CenterPanelCreateWaitingArea extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scale: 0.2,
      selectedGoogleAddress: false,
    };
  }

  waitingAreaUpdated = (properties, value) => {
    var clonedWaitingAreaForm = clone(this.props.waitingAreaForm);
    properties.map((option, i) => {
      clonedWaitingAreaForm[option] = value[i];
    }, this);
    this.props.dispatch(updateWaitingAreaForm(clonedWaitingAreaForm));
  };

  calculateDirectionOfScroll = (event) => {
    if (event instanceof Object) {
      if (event.deltaY >= 0) {
        this.doHorizontalScroll('backwards');
      } else {
        this.doHorizontalScroll('forwards');
      }
    } else {
      if (event == 'forwards') {
        this.doHorizontalScroll('forwards');
      } else {
        this.doHorizontalScroll('backwards');
      }
    }
  };

  doHorizontalScroll = (direction) => {
    let modifiedFilledCreateOrgSteps = this.props.sectionsFilled;
    if (true) {
      //TODO execute validations here
      modifiedFilledCreateOrgSteps[this.props.currentSection - 1] = true; //if no validation errors in this section, marked as complete, the -1 is because the array starts at 0
      this.props.dispatch(updateCurrentFilledWaitingAreaStep(modifiedFilledCreateOrgSteps));
    }
    if (direction == 'forwards') {
      if (this.props.currentSection < SECTIONS_NUMBER) {
        this.props.dispatch(updateCurrentCreateWaitingAreaStep(this.props.currentSection + 1));
      }
    } else if (direction == 'backwards') {
      if (this.props.currentSection > 1) {
        this.props.dispatch(updateCurrentCreateWaitingAreaStep(this.props.currentSection - 1));
      }
    } else {
      //in here direction variable has the index we want to navigate to
      this.setState({ currentSection: direction, sectionsFilled: modifiedFilledCreateOrgSteps });
    }
  };

  waitingAreaNameChanged = (value) => {
    this.waitingAreaUpdated(['name'], [value]);
  };

  handleTypingOfTimeFrom = (event) => {
    event.preventDefault();
    return false;
  };

  citySelected = (autocomplete, input) => {
    var place = autocomplete.getPlace();
    let address = '';
    let latitude = place.geometry.location.lat();
    let longitude = place.geometry.location.lng();
    let country = place.address_components.find((x) => x.types.find((y) => y == 'country'));
    if (country) country = country.long_name;
    let state = place.address_components.find((x) =>
      x.types.find((y) => y.indexOf('administrative_area_level_1') >= 0)
    );
    if (state) state = state.long_name;
    let city = place.address_components.find((x) => x.types.find((y) => y.indexOf('administrative_area_level_2') >= 0));
    if (city) city = city.long_name;
    let postalCode = place.address_components.find((x) => x.types.find((y) => y.indexOf('postal_code') >= 0));
    if (postalCode) postalCode = postalCode.long_name;

    //lets create the address here :
    let subpremise = place.address_components.find((x) => x.types.find((y) => y.indexOf('subpremise') >= 0));
    if (subpremise) address = subpremise.long_name + '-';
    let streetNumber = place.address_components.find((x) => x.types.find((y) => y.indexOf('street_number') >= 0));
    if (streetNumber) address += streetNumber.long_name;
    let route = place.address_components.find((x) => x.types.find((y) => y.indexOf('route') >= 0));
    if (route) address += ' ' + route.long_name;

    this.waitingAreaUpdated(
      ['postalCode', 'latitude', 'longitude', 'fakeAddress', 'state', 'country', 'address'],
      [postalCode, latitude, longitude, input.value, state, country, address]
    );
    this.setState(
      {
        selectedGoogleAddress: true,
      },
      () => {
        window.$(input).change();
      }
    );
  };

  waitingAreaToTimeChanged = (i, value) => {
    this.waitingAreaUpdated(['times[' + i + '].toTime'], [value]);
  };
  waitingAreaFromTimeChanged = (i, value) => {
    this.waitingAreaUpdated(['times[' + i + '].fromTime'], [value]);
  };

  daysOfWeekChanged = (index) => {
    this.waitingAreaUpdated(
      ['daysOfWeekSelected[' + index + ']'],
      [!this.props.waitingAreaForm.daysOfWeekSelected[index]]
    );
  };

  addTimeWindow = () => {
    this.waitingAreaUpdated(['times[' + this.waitingAreaForm.times.length + ']'], [{ from: '', to: '' }]);
  };
  removeTimeWindow = (index) => {
    let updatedTimesValue = this.waitingAreaForm.times.splice(index, 1);
    this.waitingAreaUpdated(['times'], [updatedTimesValue]);
  };

  waitingAreaFormTimeWindowChanged = (value) => {
    this.waitingAreaUpdated(['timeWindowSelection'], [value]);
  };

  waitingAreaFormTimezoneChanged = (value) => {
    this.waitingAreaUpdated(['timezone'], [value]);
  };

  render() {
    let classOne = 'bubble ' + (this.props.sectionsFilled[0] ? ' done' : ' pending');
    let classTwo = 'bubble' + (this.props.sectionsFilled[1] ? '  done' : ' pending');
    let classThree = 'bubble' + (this.props.sectionsFilled[2] ? ' done' : ' pending');
    let classFour = 'bubble' + (this.props.sectionsFilled[3] ? ' done' : ' pending');

    let renderInCaseOfCustomTimeWindow = '';
    if (this.props.waitingAreaForm.timeWindowSelection.Id == 1) {
      renderInCaseOfCustomTimeWindow = (
        <div>
          {this.props.waitingAreaForm.times.map((o, i) => {
            return (
              <div className="ui section " key={i}>
                <div className="two fields mrtl">
                  <ValidMe
                    validmefor="required"
                    fieldClasses="mxwdtpxxxxlllx"
                    validmemessage={APP.LANGUAGE.Errors.TimeNotSelected}
                    group="createWaitingArea"
                  >
                    <Txt
                      tabIndex="1"
                      timepicker
                      onKeyDown={this.handleTypingOfTimeFrom}
                      value={o.fromTime}
                      placeholder={APP.LANGUAGE.CreateWaitingArea.From}
                      noTitle
                      onChange={this.waitingAreaFromTimeChanged(i)}
                    />
                  </ValidMe>
                  <ValidMe
                    validmefor="required"
                    fieldClasses="mxwdtpxxxxlllx mrtnull"
                    validmemessage={APP.LANGUAGE.Errors.TimeNotSelected}
                    group="createWaitingArea"
                  >
                    <Txt
                      tabIndex="1"
                      timepicker
                      onKeyDown={this.handleTypingOfTimeTo}
                      value={o.toTime}
                      placeholder={APP.LANGUAGE.CreateWaitingArea.To}
                      noTitle
                      onChange={this.waitingAreaToTimeChanged(i)}
                    />
                  </ValidMe>
                </div>
                {APP.LANGUAGE.CreateWaitingArea.DaysOfWeek.map((o, i) => {
                  return (
                    <Txt
                      tabIndex="4"
                      checkbox
                      classes="ui checkbox pds"
                      key={i + o}
                      value={this.props.waitingAreaForm.daysOfWeekSelected[i]}
                      text={o}
                      onChange={this.daysOfWeekChanged(i)}
                    />
                  );
                })}
                <div onClick={this.removeTimeWindow(i)} className="ui button   mrbm">
                  {APP.LANGUAGE.CreateWaitingArea.RemoveTimeWindow}
                </div>
              </div>
            );
          })}
          <div onClick={this.addTimeWindow} className="ui  button mrtm  ">
            {APP.LANGUAGE.CreateWaitingArea.AddTimeWindow}
          </div>
          <ValidMe
            validmefor="required&condition"
            validmemessagecondition={APP.LANGUAGE.Errors.ResultFromList}
            condition={() => {
              return this.state.selectedGoogleAddress;
            }}
            group="createOrgUnitOne"
          >
            <Txt
              classes="google-search-field-org-unit-location"
              fieldClasses="mrtl"
              tabIndex="4"
              value={this.props.waitingAreaForm.timezone}
              placeholder={APP.LANGUAGE.CreateWaitingArea.TimezoneSelector}
              onChange={this.waitingAreaFormTimezoneChanged}
              noTitle
            />
          </ValidMe>
        </div>
      );
      //TODO: CHANGE THIS FOR AN AFTER_RENDER METHOD
      setTimeout(() => {
        let googleSelector = 'google-search-field-waiting-area-location';
        if (window.$(googleSelector).length > 0 && !window.$(googleSelector)[0].googleInjected) {
          window.$(googleSelector)[0].googleInjected = true;
          var options = {
            types: ['address'],
          };
          let autocomplete = new window.google.maps.places.Autocomplete(window.$(googleSelector)[0], options);
          autocomplete.addListener('place_changed', this.citySelected(autocomplete, window.$(googleSelector)[0]));
        }
      }, 500);
    }

    let elementsToRender = '';
    elementsToRender = (
      <div className="ui form ">
        <h4>{APP.LANGUAGE.CreateWaitingArea.TitleFirstSection}</h4>
        <ValidMe
          validmefor="length@1-50"
          fieldClasses="mxwdtpxxxxlllx"
          validmemessage={APP.LANGUAGE.Errors.WaitingAreaNameInvalidLength}
          group="createWaitingArea"
        >
          <Txt
            tabIndex="1"
            value={this.props.waitingAreaForm.name}
            placeholder={APP.LANGUAGE.CreateWaitingArea.NamePlaceholder}
            noTitle
            onChange={this.waitingAreaNameChanged}
          />
        </ValidMe>

        <ValidMe validmefor="email" fieldClasses="mxwdtpxxxxlllx" group="createWaitingArea">
          <Txt
            tabIndex="2"
            value={this.props.waitingAreaForm.email}
            placeholder={APP.LANGUAGE.CreateWaitingArea.EmailAddress}
            noTitle
            onChange={this.waitingAreaEmailChanged}
          />
        </ValidMe>

        <h4>{APP.LANGUAGE.CreateWaitingArea.SelectedConsumerTimeTitle}</h4>

        <Txt
          dropdown
          tabIndex="2"
          text={APP.LANGUAGE.CreateWaitingArea.AvailablePlaceholder}
          placeholder={APP.LANGUAGE.CreateWaitingArea.AvailablePlaceholder}
          value={this.props.waitingAreaForm.timeWindowSelection.Name}
          selectedItemPlaceholder={APP.LANGUAGE.CreateWaitingArea.AvailablePlaceholder}
          fields={'Name'}
          options={APP.LANGUAGE.CreateWaitingArea.ConsumerTimeOptions}
          onChange={this.waitingAreaFormTimeWindowChanged}
        />

        {renderInCaseOfCustomTimeWindow}
      </div>
    );

    return <span>{elementsToRender}</span>;
  }
}

function mapStateToProps(state) {
  return {
    waitingAreaForm: state.waitingAreaReducer.waitingAreaForm,
    currentSection: state.waitingAreaReducer.currentCreateWaitingAreaStep,
    sectionsFilled: state.waitingAreaReducer.currentFilledCreateWaitingAreaStep,
    scale: (1 / SECTIONS_NUMBER) * (state.waitingAreaReducer.currentCreateWaitingAreaStep - 1),
    showCenterPanelCreate: state.waitingAreaReducer.showCenterPanelCreate,
  };
}
